import AlertsReducer from './travelSecurity/alerts/actions';
import AuthReducer from './auth/auth';
import BrowserReducer from './ui/browser';
import { reducer as BurgerMenuReducer } from 'redux-burger-menu';
import ComposeReducer from './communication/compose/composeActions';
import CountriesReducer from './travelSecurity/countries/actions';
import FeedbackReducer from './communication/feedback/feedbackActions';
import FormReducer from './auth/form';
import GroupsReducer from './accounts/groups/groupsActions';
import InitReducer from './ui/init/initActions';
import LoginReducer from './auth/login';
import MapReducer from './travelSecurity/map/mapActions';
import MessagesReducer from './communication/messages/actions';
import NotificationReducer from './notification/notification.js';
import PasswordResetReducer from './auth/password';
import PlatformUsageAnalyticsReducer from './platformUsageAnalytics/platformUsageAnalytics';
import PlatformUsageReducer from './platformUsage/actions';
import SHAWAnalyticsReducer from './SHAWAnalytics/actions';
import CallCenterUtilizationReducer from './callCenterUtilization/actions';
import OnboardingReducer from 'actions/onboarding/onboardingActions';

import UsersReducer from './accounts/users/usersActions';
import { combineReducers } from 'redux';
import { i18nState } from 'redux-i18n';
import { routerReducer } from 'react-router-redux';

const reducers = {
  users: UsersReducer,
  init: InitReducer,
  auth: AuthReducer,
  groups: GroupsReducer,
  alerts: AlertsReducer,
  map: MapReducer,
  countries: CountriesReducer,
  i18nState: i18nState,
  login: LoginReducer,
  formValues: FormReducer,
  routing: routerReducer,
  passwordReset: PasswordResetReducer,
  platformUsageAnalyticsData: PlatformUsageAnalyticsReducer,
  platformUsage: PlatformUsageReducer,
  onboarding: OnboardingReducer,
  SHAWAnalytics: SHAWAnalyticsReducer,
  messages: MessagesReducer,
  compose: ComposeReducer,
  feedback: FeedbackReducer,
  notification: NotificationReducer,
  callCenterUtilization: CallCenterUtilizationReducer,
  browser: BrowserReducer,
  burgerMenu: BurgerMenuReducer
};

const rootReducer = combineReducers(reducers);

export default rootReducer;



// WEBPACK FOOTER //
// ./src/actions/rootReducer.js